import { defaultFont } from "./core";
import type { SettingsState } from "./types";

// ----------------------------------------------------------------------

export const STORAGE_KEY = "app-settings";

export const defaultSettings: SettingsState = {
	colorScheme: "light",
	direction: "ltr",
	contrast: "default",
	navLayout: "vertical",
	primaryColor: "default",
	navColor: "integrate",
	compactLayout: true,
	fontFamily: defaultFont,
} as const;
